export enum SearchParamKeys {
	Query = 'q',
	Category = 'c',
	Forced = 'f',
	Tags = 't',
	Username = 'u',
}
